
import 'reactjs-popup/dist/index.css';
import ese from './Images/ESE.png';
import iitjam from './Images/IITJAM.png';
import isro from './Images/ISRO.png';
import gate from './Images/GATE.png';

// import IISR from './Images/iiser_logo.png'
export const Exam_Explore_data = [
  {
    exams_buttons: "exams_buttons",
    exam_boxs: "exam_boxs",
    exams_button: "GATE ",
    ots: "online test series",
    olvc: "live online video class",
    otslink: "/OnlineTestSerieshome/01",
    olvclink: "/OnlineLiveClassesHomePage/JEEMain",
    Orvc: "Recorded Online Video Lectures",
    OrvcLink: "/OnlineRecordedLecturesHomePage/01",
    // examPage: "/JEEMainHomePage",
    examPage:"/Exams/GATEHomePage",
    exams_buttons_normal: "exams_buttons_normal",
    exam_image:gate,
  },
  {
    exams_buttons: "exams_buttons",
    exam_boxs: "exam_boxs",
    exams_button: "IIT JAM ",
    ots: "online test series",
    olvc: "live online video class",
    otslink: "/OnlineTestSerieshome/09",
    olvclink: "/JEEAdvanceOnlineLiveClassesHomePage",
    Orvc: "Recorded Online Video Lectures",
    OrvcLink: "/OnlineRecordedLecturesHomePage/09",
    // examPage: "/JEEAdvancedHomePage",
    examPage:"/Exams/IITJAMHomePage",
    exams_buttons_normal: "exams_buttons_normal",
    exam_image:iitjam,
  },
  
  {
    exams_buttons: "exams_buttons",
    exam_boxs: "exam_boxs",
    exams_button: "ISRO",
    Orvc: "Recorded Online Video Lectures",
    OrvcLink: "/OnlineRecordedLecturesHomePage/03",
    ots: "online test series",
    olvc: "live online video class",
    otslink: "/OnlineTestSerieshome/03",
    olvclink: "/BITSATOnlineLiveClassesHomePage",
    // examPage: "/BITSATHomePage",
    examPage:"/Exams/ISROHomePage",
    exams_buttons_normal: "exams_buttons_normal",
    exam_image:isro,
  },
 {
    exams_buttons: "exams_buttons",
    exam_boxs: "exam_boxs",
    exams_button: "ESE (Prelims)",
    Orvc: "Recorded Online Video Lectures",
    OrvcLink: "/OnlineRecordedLecturesHomePage/02",
    ots: "online test series",
    olvc: "live online video class",
    otslink: "/OnlineTestSerieshome/02",
    olvclink: "/NEETOnlineLiveClassesHomePage",
    // examPage: "/NEETHomePage",
    examPage:"/Exams/ESEHomePage",
    exams_buttons_normal: "exams_buttons_normal",
    exam_image:ese,
  }

  // {
  //   exams_buttons: "exams_buttons",
  //   exam_boxs: "exam_boxs",
  //   exams_button: "UGEE",
  //   ots: "online test series",
  //   otslink: "/OnlineTestSerieshome/24",
  //   olvc: "",
  //   examPage: "/UgExamHomePage/24",
  //   exams_buttons_normal: "exams_buttons_normal",
  //   olvclink:"",
  //   exam_image:ugjee,
  // },
  // {
  //   exams_buttons: "exams_buttons",
  //   exam_boxs: "exam_boxs",
  //   exams_button: "IISER",
  //   ots: "online test series",
  //   otslink: "/OnlineTestSerieshome/25",
  //   olvc: "",
  //   examPage: "/UgExamHomePage/25",
  //   exams_buttons_normal: "exams_buttons_normal",
  //   olvclink:"",
  //   exam_image:IISR,
  // },
];

export const Examsliders = [

];
